/**
 * 桌面授权云端激活客户端 —— 打运营方公网 API(非本机 sidecar)。
 * 见 docs/plans/licensing-activation.md。
 */

export interface ActivationResult {
  ulid: string
  /** 新服务端返回规范 SHA-256;可选以兼容客户端先于服务端发布。 */
  fingerprint?: string
  shop_name: string
  trial_started_at: string
  expires_at: string | null
  trial_ends_at: string
}

const BASE =
  import.meta.env.VITE_ACTIVATION_BASE_URL || 'https://api.vip0101.com/api/v1'

/** 带 HTTP 状态码的错误,调用方可按 status 决定要不要 fallback/重试。 */
export class ActivationHttpError extends Error {
  constructor(
    message: string,
    public readonly status: number
  ) {
    super(message)
    this.name = 'ActivationHttpError'
  }
}

async function post<T>(path: string, body: unknown): Promise<T> {
  const resp = await fetch(`${BASE}${path}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify(body)
  })
  if (!resp.ok) {
    let msg = `HTTP ${resp.status}`
    try {
      const j = (await resp.json()) as { message?: string; error?: string }
      msg = j.message || j.error || msg
    } catch {
      /* ignore */
    }
    throw new ActivationHttpError(msg, resp.status)
  }
  return resp.json() as Promise<T>
}

export async function registerActivation(input: {
  fingerprint: string
  shop_name: string
  trial_started_at: string
}): Promise<ActivationResult> {
  return post('/activation/register', input)
}

export async function heartbeatActivation(fingerprint: string): Promise<ActivationResult> {
  return post('/activation/heartbeat', { fingerprint })
}
